<template>
  <section class="why-teams-section">
    <h2 class="section-title">Why Teams Choose SodaSoft.io</h2>
    <p class="section-subtitle">
      Our platform is designed specifically for automotive dealerships and their unique
      <br />
      needs.
    </p>
    <div class="reasons-grid">
      <div class="reason-box" v-for="reason in reasons" :key="reason.title">
        <div class="reason-icon" v-html="reason.icon"></div>
        <h3 class="reason-title">{{ reason.title }}</h3>
        <p class="reason-desc">{{ reason.description }}</p>
      </div>
    </div>
  </section>
  <br />
  <br />
  <br />
  <section class="cta-section">
    <div class="cta-content">
      <h2 class="cta-title">Ready to Elevate Your Dealership?</h2>
      <p class="cta-subtitle">
        Join dealerships nationwide who are using SodaSoft.io to transform their inventory
        merchandising.
      </p>
      <div class="cta-buttons">
        <a href="#login" class="btn btn-white">Get Started</a>
        <button class="btn btn-outline" @click="showDemo = true">Contact Us for a Demo</button>
      </div>
    </div>
    <!-- Request Demo Dialog -->
    <Dialog
      v-model:visible="showDemo"
      modal
      style="width: 90%; max-width: 400px"
      class="demo-dialog"
    >
      <template #header>
        <div style="padding: 1rem 20px; font-weight: 600; font-size: 1.25rem">Contact Our Team</div>
      </template>
      <div class="p-fluid">
        <div class="field">
          <label for="demo-email">Email</label>
          <InputText id="demo-email" v-model="demoEmail" type="email" required />
        </div>
        <div class="field mt-2">
          <label for="demo-phone">Contact No</label>
          <InputText id="demo-phone" v-model="demoPhone" type="text" />
        </div>
        <div class="field mt-2">
          <label for="demo-message">Your Query</label>
          <Textarea id="demo-message" v-model="demoMessage" rows="4" />
        </div>
        <div class="flex justify-content-end mt-3">
          <Button id="btn-request-demo" icon="pi pi-check" label="Submit" @click="submitDemo" />
        </div>
      </div>
    </Dialog>
  </section>
</template>

<script setup>
const reasons = [
  {
    title: 'Industry Focused',
    description: 'Built for the automotive industry—no generic CMS bolt-ons',
    icon: `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' stroke='#2a68ed' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M9 11l3 3L22 4'/><path d='M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11'/></svg>`,
  },
  {
    title: 'Trusted Nationwide',
    description: 'Trusted by dealerships and marketing agencies nationwide',
    icon: `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' stroke='#2a68ed' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><circle cx='12' cy='12' r='10'/><path d='M12 6v6l4 2'/></svg>`,
  },
  {
    title: 'Reliable Support',
    description: 'Reliable support and updates to stay compliant with Google and OEM guidelines',
    icon: `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' stroke='#2a68ed' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M20 21v-2a4 4 0 0 0-3-3.87'/><path d='M4 21v-2a4 4 0 0 1 3-3.87'/><circle cx='12' cy='7' r='4'/></svg>`,
  },
  {
    title: 'Unified Platform',
    description: 'One login. One platform. All your tools in one place.',
    icon: `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' stroke='#2a68ed' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><circle cx='12' cy='12' r='10'/><path d='M14.31 8l5.74 9.94'/><path d='M9.69 8h11.48'/></svg>`,
  },
]
import { ref, onMounted, onUnmounted } from 'vue'
const showDemo = ref(false)
const demoEmail = ref('')
const demoPhone = ref('')
const demoMessage = ref('')
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
function submitDemo() {
  console.log('Demo Request:', demoEmail.value, demoPhone.value, demoMessage.value)
  showDemo.value = false
}
</script>

<style scoped>
.why-teams-section {
  text-align: center;
  padding: 60px 30px;
  max-width: 1340px;
  margin: 0 auto;
  width: 100%;
}
.section-title {
  color: #0f1729;
  font-size: 36px;
  letter-spacing: -1px;
  font-weight: 700;
}
.section-subtitle {
  color: #64748b;
  font-size: 18px;
  margin-bottom: 40px;
}
.reasons-grid {
  margin-top: 40px;
  /* border:2px solid red; */
  display: grid;
  gap: 20px;
  max-width: 1020px;
  margin: auto;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}
.reason-box {
  background-color: white;
  border: 1px solid rgb(240, 240, 240);
  border-radius: 10px;
  padding: 20px;
  text-align: center;
}
.reason-icon svg {
  margin-bottom: 10px;
}
.reason-title {
  font-weight: 600;
  color: #0f1729;
  font-size: 16px;
}
.reason-desc {
  color: #64748b;
  font-size: 14px;
}

.cta-section {
  background-color: #2563eb;
  padding: 120px 20px;
  color: white;
  text-align: center;
}
.cta-content {
  max-width: 700px;
  margin: 0 auto;
}
.cta-title {
  font-size: 36px;
  letter-spacing: -1px;
  font-weight: 700;
}
.cta-subtitle {
  margin: 0px 0 30px;
  font-size: 18px;
  color: #e2e8f0;
}
.cta-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}
.btn {
  padding: 10px 30px;
  font-weight: 600;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-white {
  background-color: white;
  color: #2563eb;
  border: none;
  text-decoration: none;
}
.btn-white:hover {
  background-color: #f1f5f9;
}
.btn-outline {
  border: 1px solid white;
  color: white;
  background-color: transparent;
}
.btn-outline:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
/* Input + Textarea Styling */
.p-inputtext,
.p-inputtextarea {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #0f172a;
  background-color: white;
  box-shadow: none;
  margin-top: 5px;
}

.p-inputtext::placeholder,
.p-inputtextarea::placeholder {
  color: #94a3b8;
}

.p-inputtext:focus,
.p-inputtextarea:focus {
  border-color: #2563eb;
  outline: none;
  box-shadow: 0 0 0 1px #2563eb;
}

.login-link {
  font-size: 0.9rem;
  color: #444;
  text-decoration: none;
}

.login-link:hover {
  color: #0073ff;
}

.demo-dialog .p-dialog-header {
  padding: 1rem 1.5rem !important;
}

.p-fluid {
  padding: 20px;
}
#btn-request-demo {
  background-color: #2a68ed !important;
  color: white;
  padding: 7px 13px;
  border-radius: 6px;
  font-size: 14px;
}

#btn-request-demo:hover {
  background-color: #3874f6 !important;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 26px;
    line-height: 35px;
    text-align: start;
  }
  .section-subtitle {
    margin-top: 10px;
    font-size: 16px;
    text-align: start;
  }
}
</style>
